import { StyledAutoHeightTextArea } from "./style";
import useAutoHeightTextArea from "./useAutoHeightTextArea";
import { Icons } from "contents/icons";
import { Icon } from "components/icon/Icon";

export const AutoHeightTextArea = ({
  value,
  onValueChange,
  onKeyDown,
  onKeyUp,
  maxLength,
  maxHeight,
  placeholder,
  icon,
  style,
}: {
  value: string;
  onValueChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  onKeyUp?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  maxLength?: number;
  maxHeight?: string;
  placeholder?: string;
  icon?: keyof typeof Icons;
  style?: React.CSSProperties;
}) => {
  const { textareaRef, handleTextareaChange } = useAutoHeightTextArea(
    value,
    onValueChange
  );

  return (
    <StyledAutoHeightTextArea>
      <textarea
        ref={textareaRef}
        style={{
          ...(maxHeight ? { maxHeight: maxHeight, overflowY: "auto" } : {}),
          ...style,
        }}
        value={value}
        onChange={handleTextareaChange}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        placeholder={placeholder}
        maxLength={maxLength}
      ></textarea>
      {!value && icon && (
        <Icon
          className="icon"
          size={16}
          stroke="--text-gray-4"
          icon={icon}
          strokeWidth={0.5}
        />
      )}
    </StyledAutoHeightTextArea>
  );
};

export default AutoHeightTextArea;
